import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  gajiPph21Service = {}

gajiPph21Service.data = function (token,data='') {
    return fetch({
        url: '/transaksi/gaji_pph21/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

gajiPph21Service.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_pph21/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

gajiPph21Service.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_pph21/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

gajiPph21Service.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/gaji_pph21/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default gajiPph21Service;
